import game_day from '@gameday/common/assets/images/game_day.svg'

import commonStyles from '../../../shared/styles/common-styles.scss'

const ErrorPage = ({ errorMessage, errorDescription }) => (
  <div className={commonStyles.splashPageContainer}>
    <div className={commonStyles.contentContainer}>
      <img style={{ marginBottom: 40 }} src={game_day} alt="game_day_logo" />
      <h2>{errorMessage}</h2>
      {errorDescription && <h3>{errorDescription}</h3>}
    </div>
  </div>
)

ErrorPage.defaultProps = {
  errorMessage: 'Oops! Something went wrong',
  errorDescription: null,
}

export default ErrorPage
